export type Atom = bigint | boolean | number | string
